function Main({ children }) {
	return <main className='main'>{children}</main>;
}

export default Main;
